export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Head_BaseColor.8561e130.tga";